import { Coordinate } from '../model/coordinate';

import { drawHorizontalLine, LineStyle, LineWidth, setLineStyle } from './draw-line';
import { IPaneRenderer } from './ipane-renderer';

export interface HorizontalLineRendererData {
	color: string;
	height: number;
	lineStyle: LineStyle;
	lineWidth: LineWidth;

	y: Coordinate;
	visible?: boolean;
  width: number;
  x?: Coordinate;
}

export class HorizontalLineRenderer implements IPaneRenderer {
	private _data: HorizontalLineRendererData | null = null;

	public setData(data: HorizontalLineRendererData): void {
		this._data = data;
	}

	public isSpecial(): boolean {
		return false;
	}

	public draw(ctx: CanvasRenderingContext2D, paneID: number, pixelRatio: number, isHovered: boolean, hitTestData?: unknown): void {
		if (this._data === null) {
			return;
		}

		if (this._data.visible === false) {
			return;
		}

		const y = Math.round(this._data.y * pixelRatio);

		if (y < 0 || y > Math.ceil(this._data.height * pixelRatio)) {
			return;
		}

		let width = Math.ceil(this._data.width * pixelRatio);
		ctx.lineCap = 'butt';
    ctx.strokeStyle = this._data.color;

		ctx.lineWidth = Math.floor(this._data.lineWidth * pixelRatio);
    setLineStyle(ctx, this._data.lineStyle);


    // if(this._data.color=="#ffd500")
    // {
    //   //console.log("B");
    //   //console.log(this._data);
    // }

    let starting = 0;
    if(this._data.x!=undefined)
    {
      starting = pixelRatio*this._data.x;
    //  width = width-starting;
    }

		drawHorizontalLine(ctx, y, starting, width);
	}
}
